<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>待处理</el-breadcrumb-item>
    </el-breadcrumb>
    <customer-list :repeat="true"></customer-list>
  </div>
</template>

<script>
import CustomerList from './list'
export default {
  props: {
    dealerID: {
      type: Number,
      default: 0,
    },
  },
  components: { CustomerList },
}
</script>